import React from "react";
import siteContent from "../../generated/site-content";

function Avatar({ compact = false }) {
  const sizeClasses = compact
    ? "w-[min(56vw,12.5rem)] xs:w-[12rem] sm:w-[13rem] fold:w-[13.5rem] md:w-[clamp(13rem,21vw,15rem)] lg:w-[clamp(14.5rem,17vw,18rem)] 3xl:w-[18rem] 4xl:w-[19rem] 6xl:w-[20rem]"
    : "w-[min(62vw,13.5rem)] xs:w-[13rem] sm:w-[14rem] fold:w-[15rem] md:w-[clamp(14rem,24vw,17rem)] lg:w-[clamp(15rem,20vw,18rem)] 3xl:w-[19rem] 4xl:w-[22rem] 6xl:w-[24rem]";

  return (
    <div className="mx-auto w-fit lg:mx-0">
      <div className="theme-surface overflow-hidden rounded-full border theme-border">
        <img
          src={siteContent.avatar.src}
          alt={siteContent.avatar.alt}
          sizes={
            compact
              ? "(min-width: 2560px) 18rem, (min-width: 1920px) 16rem, (min-width: 1024px) 15rem, (min-width: 768px) 14rem, 54vw"
              : "(min-width: 2560px) 22rem, (min-width: 1920px) 19rem, (min-width: 1024px) 18rem, (min-width: 768px) 16rem, 62vw"
          }
          className={`aspect-square object-cover object-center ${sizeClasses}`}
        />
      </div>
    </div>
  );
}

export default Avatar;
